var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgToCplus = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.647 3.384A11.43 11.43 0 0 0 11.5 0C5.171 0 .013 5.148.001 11.477a11.43 11.43 0 0 0 3.352 8.139A11.43 11.43 0 0 0 11.479 23h.023C17.829 23 22.988 17.851 23 11.521a11.42 11.42 0 0 0-3.353-8.137M17.5 12.012v-.006L12 12v5.5a.5.5 0 0 1-1 0v-5.495L5.499 12a.5.5 0 0 1 .001-1v-.005L11 11V5.5a.5.5 0 0 1 1 0v5.494l5.501.006c.275.012.5.235.499.512a.5.5 0 0 1-.5.5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgToCplus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/TOCplus.svg";